
import jsPDF from 'jspdf';
import { PDFReportData } from '@/types/pdf';
import { PDF_STYLES } from './pdf/pdfStyles';
import { addLogoAndCompanyInfo, addReportHeader } from './pdf/pdfHeader';
import { addReportSummary } from './pdf/pdfSummary';
import { addBooksBreakdownTable } from './pdf/pdfTable';
import { addFooter } from './pdf/pdfFooter';

export const generateQuarterlyRoyaltyReportPDF = async (data: PDFReportData) => {
  const pdf = new jsPDF();
  const { margin, rightMargin, lineWidth } = PDF_STYLES;
  const pageWidth = pdf.internal.pageSize.width;
  let yPosition = margin;

  // Add logo and company information
  yPosition = await addLogoAndCompanyInfo(pdf, yPosition);
  
  // Horizontal line separator
  pdf.setLineWidth(lineWidth.normal);
  pdf.line(margin, yPosition, pageWidth - rightMargin, yPosition);
  yPosition += 12;
  
  // Add report header
  yPosition = addReportHeader(pdf, data.quarter, data.year, data.authorName, yPosition);
  
  // Add report summary sections
  yPosition = addReportSummary(pdf, data, yPosition);
  
  // Add books breakdown table
  yPosition = addBooksBreakdownTable(pdf, data, yPosition);
  
  // Add footer
  addFooter(pdf, yPosition);
  
  // Download the PDF
  pdf.save(`Royalty_Report_Q${data.quarter}_${data.year}_${data.authorName.replace(/\s+/g, '_')}.pdf`);
};
